import styled from '@emotion/styled';
import { Table, Dimmer, Loader } from 'semantic-ui-react';
import { MemoTableRow } from './MemoTableRow';
import { MemoTableHeader } from './MemoTableHeader';
import { useExamDatesForLocationsCentreContext } from './useExamDatesForLocationsCentreContext';
import { Footer } from '../common/Footer';
import { UnsavedChangesModal } from '../common/UnsavedChangesModal';

export const ExamDatesForLocationsCentreContext = () => {
  const {
    date,
    tableData,
    isDataLoading,
    isLoadingButtons,
    isModified,
    onSave,
    onDiscard,
    onDateChange,
    onChange,
  } = useExamDatesForLocationsCentreContext();

  return (
    <S.Container>
      <UnsavedChangesModal isModified={isModified} />
      <S.DimmerDimmable dimmed={isDataLoading} basic attached>
        <S.Dimmer active={isDataLoading} inverted>
          <Loader active={isDataLoading}>Loading...</Loader>
        </S.Dimmer>
        <S.Content>
          <S.Table attached="top" striped>
            <MemoTableHeader date={date} onDateChange={onDateChange} />
            <Table.Body>
              {tableData.map((row, rowIndex) => (
                <MemoTableRow
                  date={date}
                  key={row.locationId}
                  rowData={row}
                  rowIndex={rowIndex}
                  isEditable={row.isEditable}
                  onCellChange={onChange}
                />
              ))}
            </Table.Body>
          </S.Table>
        </S.Content>
      </S.DimmerDimmable>
      <Footer
        isModified={isModified}
        isLoadingButtons={isLoadingButtons}
        onDiscard={onDiscard}
        onSave={onSave}
      />
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    height: calc(100vh - 50px);
    display: grid;
    grid-template-rows: [content] 1fr [footer] 65px;
  `,
  Content: styled.div`
    width: calc(100vw - 260px);
    overflow: auto;
    height: 100%;
  `,
  Table: styled(Table)`
    max-height: 80% !important;
    overflow: auto;
    td:nth-of-type(1),
    th:nth-of-type(1) {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 0;
    }
    th:nth-of-type(1) {
      background: #ffffff;
    }
    tbody tr:nth-of-type(odd) td:nth-of-type(1) {
      background: #fafafb;
    }

    tbody tr:nth-of-type(even) td:nth-of-type(1) {
      background: #ffffff;
    }
    td:not(:first-of-type) {
      padding: 0 !important;
    }

    &.ui.table,
    &.ui.table.attached {
      border: 0;
      margin: 0;
      width: 100%;
      max-width: 100%;
    }
    &.ui.table {
      font-size: 12px;

      td {
        vertical-align: inherit;
      }
    }
  `,
  Dimmer: styled(Dimmer)`
    &.ui.dimmer {
      z-index: 2;
    }
  `,
  DimmerDimmable: styled(Dimmer.Dimmable)`
    &.ui.attached.segment {
      height: calc(100% - 70px);
      width: 100%;
      overflow: auto;
    }
  `,
};
